import * as R from "ramda";
import moment from "moment";
import { Tree } from "antd";
import React, { useEffect, useMemo, useState } from "react";

import { VideoResourceTab } from "./video-resource-tab";
import { projectMediaSourcesOrderDateArea } from "../aliyun-service-api";

/**
 * 获取树形结构数据
 * {"admin_list":[{"id":101409,"nickname":"罗勋","oper":"admin,videomen,cameramen","department":59,"trash":0},{"id":102616,"nickname":"研发-曹巍","oper":"consult,admin","department":59,"trash":0}],"date_area":[{"admin_id":102616,"date_time":"20240811","date_count":1},{"admin_id":101409,"date_time":"20240911","date_count":1},{"admin_id":102616,"date_time":"20240911","date_count":3},{"admin_id":102616,"date_time":"20240912","date_count":1}]}
 *
 * admin_list是所有出现在date_area中的admin_id
 *
 * 最终呈现的是一个树形结构
 *
 * 研发-曹巍(1+3+1)
 *  20240811(1)
 *  20240911(3)
 *  20240912(1)
 * 罗勋(1)
 *  20240911(1)
 */
export const getTreeData = (orderId) => {
  return new Promise((resolve, reject) => {
    projectMediaSourcesOrderDateArea(orderId).then((res) => {
      const adminList = R.pathOr([], ["admin_list"], res);
      const dateArea = R.pathOr([], ["date_area"], res);
      const treeData = adminList.map((admin) => {
        const adminId = admin.id;
        const adminName = admin.nickname;
        const adminDates = dateArea
          .filter((date) => date.admin_id === adminId)
          .map((date) => ({
            ...date,
            key: `${adminId}-${R.pathOr("", ["date_time"], date)}`,
            title:
              R.pathOr("", ["date_time"], date) +
              "(" +
              R.pathOr(0, ["date_count"], date) +
              ")",
            isLeaf: true,
          })).sort((a, b) => {
            const aDate = moment(a.date_time);
            const bDate = moment(b.date_time);
            return aDate.isBefore(bDate) ? 1 : -1;
          });

        const totalCount = adminDates.reduce(
          (sum, date) => sum + R.pathOr(0, ["date_count"], date),
          0
        );
        return {
          key: adminId.toString(),
          title: `${adminName}(${totalCount})`,
          children: adminDates,
        };
      });

      resolve(treeData);
    }, reject);
  });
};

/**
 * 这个组件是放置在页面左边的一个树形结构, 数据源是<getTreeData>
 * <Tree> ... <TreeNode...> </Tree>
 * @param props
 * @constructor
 */
export const TreeOfMediaSources = (props) => {
  const orderId = R.pathOr("0", ["match", "params", "orderid"], props) * 1;
  const [treeData, setTreeData] = useState([]);

  useEffect(() => {
    if (!orderId) {
      return;
    }
    getTreeData(orderId).then(setTreeData);
  }, [orderId]);

  return (
    <Tree
      {...props}
      key={JSON.stringify(treeData)}
      blockNode
      showIcon
      defaultExpandAll
      treeData={treeData}
    />
  );
};

/**
 * @param props
 * @returns {Element}
 * @constructor
 */
export const EquipmentUploadPage = (props) => {
  const orderId = R.pathOr("0", ["match", "params", "orderid"], props) * 1;
  const selectedKeys = R.pathOr([], ["selectedKeys"], props);
  const firstKey = selectedKeys[0];
  const extraParams = R.pathOr({}, ["extraParams"], props);

  const extra = useMemo(() => {
    const [adminId, date] = firstKey.split("-");
    let params = { ...extraParams };
    if (adminId) {
      params.admin_id = adminId;
    }
    /**
     * date是一个字符串, 例如"20240911"
     *
     * begin_time=1725123661&end_time=1726133679
     */
    if (date) {
      const begin_time = moment(date).unix();
      const end_time = moment(date).add(1, "day").unix();
      params.begin_time = begin_time;
      params.end_time = end_time;
    }
    return params;
  }, [firstKey, extraParams]);
  useEffect(() => {
    if (!orderId) {
      return;
    }
    getTreeData(orderId).then(console.log);
  }, [orderId]);
  return (
    <div key={firstKey}>
      <VideoResourceTab orderId={orderId} {...props} extraParams={extra} />
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/containers/Video/tab-pages/equipment-upload-page.js